import React from 'react'

export default function GuestHome(props) {
    return (
        <main>
            <div className="p-5 pb-md-4 mx-auto text-center">
                <h2 className="display-4 fw-normal">
                    Program Assessment Reporting
                </h2>
                <p className="fs-5 text-muted">
                Report program assessment efforts at the office, from home, or on the go.
                </p>
            </div>
            <div className="page-content mx-auto text-center fs-4 text-muted">
                You are not signed in. Please sign in.
            </div>
        </main>
    )
}